module.exports = __webpack_public_path__ + "img/resource07.7b1b938f.png";